module.exports = __webpack_public_path__ + "static/media/1.6cb9b5eb.jpg";